import { render, staticRenderFns } from "./dossier.vue?vue&type=template&id=1b8e0f2c&"
import script from "./dossier.vue?vue&type=script&lang=js&"
export * from "./dossier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports